import { Component, inject } from '@angular/core';
import { FolderGlobalStore } from '../../../../../../store/medicalService/folder.global-store';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';
import { routeParams } from '../../../../../shared/shared.global-service';
import { PersonContactsPageComponent } from '../person-contacts-page/person-contacts-page.component';

@Component({
    selector: 'app-person-contacts-dialog',
    templateUrl: './person-contacts-dialog.component.html',
    styleUrl: './person-contacts-dialog.component.scss',
    imports: [
        PersonContactsPageComponent,

    ],
    providers: [
        FolderGlobalStore,
    ],
})
export class PersonContactsDialogComponent extends BaseDialogComponent {

    protected readonly folderStore = inject(FolderGlobalStore);

    constructor() {
        super();
        this.folderStore.setFolderId(routeParams.folderId());
        this.folderStore.setDialogComponent(this);
    }
}
